/**
 * @desc Filter文件
 * @file config.js
 * @author dingzhenyue@baidu.com
 */

import dayjs from 'dayjs';

/**
 * 用户身份
 * @param {String} value 用户身份值
 * @returns 用户身份中文
 */

export const userTypeFilter = value => {
    let data = ['律师', '律所律师'];
    return data[value] || '-';
};

/**
 * 日期
 * @param {Number} date 时间戳（s）
 * @returns 日期（2022-10-10）
 */

export const dateFilter = date => {
    if (!date) {
        return '-';
    }
    return dayjs(new Date(Number(date) * 1000).getTime()).format('YYYY-MM-DD');
};

/**
 * 城市
 * @param {String} cityName 城市编码字符串  100000$100000
 * @returns 城市（北京市）
 */

export const cityNameFilter = cityName => {
    if (!cityName) {
        return '-';
    }
    return cityName.split('$').length > 1 ? cityName.split('$')[1] || '-' : cityName;
};
